/**
 * Chart beforeDraw plugin for Doughnut charts
 * @param {Object} chart - Chart.js chart instance
 * @param {number} percentFact - Percentage value
 * @param {number} thresholdFactSum - Fact sum value
 * @param {number} thresholdSum - Threshold sum value
 * @param {string} currency - Currency symbol (default: "€")
 */
export const beforeDraw = (
	chart,
	percentFact,
	thresholdFactSum,
	thresholdSum,
	currency = "€"
) => {
	const width = chart.width
	const height = chart.height
	const ctx = chart.ctx
	ctx.restore()
	ctx.font = "bold 24px sans-serif"
	ctx.textBaseline = "center"
	ctx.fillStyle = "#2E2E2E"
	const text = `${percentFact}%`
	const textX = Math.round((width - ctx.measureText(text).width) / 2)
	const textY = height / 2
	ctx.fillText(text, textX, textY)
	ctx.save()
	ctx.font = "14px sans-serif"
	ctx.fillStyle = "#707070"
	const text2 = `${currency}${thresholdFactSum} / ${currency}${thresholdSum}`
	const textX2 = Math.round((width - ctx.measureText(text2).width) / 2)
	const textY2 = height / 1.55
	ctx.fillText(text2, textX2, textY2)
	ctx.save()
}

/**
 * Create matrix helper function
 * @param {number} m - Number of columns
 * @param {number} n - Number of rows
 * @returns {Array} - Matrix array
 */
export const createMatrix = (m, n) => {
	const result = []
	for (let i = 0; i < n; i++) {
		result.push(new Array(m).fill(null))
	}
	return result
}

